import { render } from "./UploadFeedback.vue?vue&type=template&id=371a82b3"
import script from "./UploadFeedback.vue?vue&type=script&lang=js"
export * from "./UploadFeedback.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__